export default __webpack_public_path__ + "static/media/tegarock-l-rockwool-komposition_comp.78575826.jpg";